import React from "react";
import PropTypes from "prop-types";
import {findDOMNode} from "react-dom";
import PopoverMenuSeparator from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator";
import PopoverMenuHeader from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-header";
import {PopoverMenuItemType} from "../../../../../gd-components/popover-menu/popover-menu/const";
import FieldMultiselect from "../../../../generic/multiselect/multiselect";
import PopoverGroupHeader from "./group-option";
import {GROUP_HEADER_TYPE} from "./build-options";

export default class FieldUsers_PopoverOptionsSelector extends React.Component<any,any> {

    public optionRef : any

    static propTypes = {
        parent              : PropTypes.object,
        field               : PropTypes.object,
        options             : PropTypes.array.isRequired,
        keyboardNavigation  : PropTypes.bool,
        onUpdateScroll      : PropTypes.func,
        onGroupHeaderClick  : PropTypes.func,
        onToggleGroup       : PropTypes.func,
    }

    static defaultProps = {
        keyboardNavigation: true
    }

    constructor(props:any) {
        super(props);
        this.state = { currentCursorValue: null };
        this.optionRef = {};
    }

    componentDidUpdate(prevProps:any, prevState:any) {
        const node = this.state.currentCursorValue !== null
            ? findDOMNode(this.optionRef[this.state.currentCursorValue])
            : null;
        if (node) this.props.onUpdateScroll(node);
    }

    _getNavigableOptions = (options: any[]) => options.filter((o: any) => !o.type)

    onClickOption = (option: any, e: React.MouseEvent | React.KeyboardEvent) => {
        this.props.parent.onOptionClick(option, e)
    }

    onChangeCursorValue = (newValue: any) => {
        this.setState({ currentCursorValue: newValue });
    }

    onPopoverKeyDown = (event:any) => {
        if (!this.props.keyboardNavigation) return;

        const navigable = this._getNavigableOptions(this.props.options);

        switch(event.key) {
            case 'Escape': this.props.parent.hidePopover(); break;

            case 'ArrowUp': {
                const idx = navigable.findIndex((o: any) => o.value === this.state.currentCursorValue)
                const newIdx = idx <= 0 ? 0 : idx - 1
                this.onChangeCursorValue(navigable[newIdx]?.value ?? null)
                break
            }

            case 'ArrowDown': {
                const idx = navigable.findIndex((o: any) => o.value === this.state.currentCursorValue)
                const newIdx = idx < 0 ? 0 : Math.min(idx + 1, navigable.length - 1)
                this.onChangeCursorValue(navigable[newIdx]?.value ?? null)
                break
            }

            case 'Enter':
                if (this.state.currentCursorValue !== null) {
                    const curOption = navigable.find((o: any) => o.value === this.state.currentCursorValue)
                    if (curOption) this.onClickOption(curOption, event);
                }
                break;
        }
    }

    render() {
        const field : FieldMultiselect = this.props.field;
        const options: any[] = this.props.options;

        const selectedValues: any[] = this.props.parent.state.currentOptions
            ?? field.getViewValue(this.props.model)
            ?? []

        const elements: React.ReactNode[] = []
        let inGroup = false

        options.forEach((option: any, key: number) => {
            if (option.type === PopoverMenuItemType.SEPARATOR) {
                inGroup = false
                elements.push(<PopoverMenuSeparator key={key} />)
                return
            }

            if (option.type === PopoverMenuItemType.HEADER) {
                inGroup = false
                elements.push(<PopoverMenuHeader key={key} title={option.title} />)
                return
            }

            if (option.type === GROUP_HEADER_TYPE) {
                inGroup = true
                elements.push(<PopoverGroupHeader key={key}
                                                  title={option.title}
                                                  groupValues={option.groupValues}
                                                  selectedValues={selectedValues}
                                                  isCollapsed={!!option.isCollapsed}
                                                  onGroupClick={this.props.onGroupHeaderClick}
                                                  onToggleCollapse={()=>this.props.onToggleGroup(option.title)}/>)
                return
            }

            const isHighlighted = this.state.currentCursorValue !== null
                && option.value === this.state.currentCursorValue

            const optionEl = <field.components.PopoverOption ref={(r:any)=>this.optionRef[option.value] = r}
                                                             key={option.isAllValuesOption ? 'all_values' : option.value}
                                                             option={option}
                                                             isHighlighted={isHighlighted}
                                                             isSelected={selectedValues.includes(option.value)}
                                                             onClick={(e: React.MouseEvent)=>this.onClickOption(option, e)}/>

            elements.push(inGroup
                ? <div key={key} className="p-l-20">{optionEl}</div>
                : optionEl
            )
        })

        return <>{elements}</>
    }
}
